import { render, staticRenderFns } from "./UserQualification.vue?vue&type=template&id=7f8ab52e&scoped=true"
import script from "./UserQualification.vue?vue&type=script&lang=js"
export * from "./UserQualification.vue?vue&type=script&lang=js"
import style0 from "./UserQualification.vue?vue&type=style&index=0&id=7f8ab52e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8ab52e",
  null
  
)

export default component.exports